import card from './card'
import content from './content'
import create from './create'
import empty from './empty'
import form from './form'
import remove from './remove'
import update from './update'

export default {
    card,
    content,
    create,
    empty,
    form,
    update,
    remove,

    reply: 'Antworten',
    comments: '1 Kommentar | {count} Kommentare'
}
